// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"f3498f006fb441f0bf3f","873":"a5342b65654176ad295c"}[chunkId] + ".js";
};